var yswSO = {};
(function($) {
	yswSO = {
		settings: {
			swatch_type: '',
			option_names: [],
			img_cdn_url: '',
			free_swatch_img_desktop: '',
			free_swatch_img_mobile: '',
			heading_suffix: '',
			color_popup_scroll_top: null // Track scroll-based position for color swatches
		},
		update_color_popup_position: function() {
			// Calculate popup position to maintain fixed viewport position (regardless of scroll)
			if (window.matchMedia && window.matchMedia('(min-width: 769px)').matches) {
				var scrollTop = $(window).scrollTop();
				var $colorSwatchContainer = $('.ysw-swatch-options[data-position="0"]');
				
				if ($colorSwatchContainer.length > 0) {
					var containerTop = $colorSwatchContainer.offset().top;
					
					// Fixed viewport position: 180px from top of visible screen (adjusted for lower position)
					var desiredViewportTop = 180;
					var desiredDocumentTop = scrollTop + desiredViewportTop;
					
					// Convert to position relative to container
					var popupTop = desiredDocumentTop - containerTop;
					
					// Store the calculated position
					yswSO.settings.color_popup_scroll_top = Math.round(popupTop);
				}
			}
		},
		set_preview_swatch_position: function(current_swatch) {
			var $swatchContainer = current_swatch.closest('.ysw-swatch-options');
			var swatch_wrap_position = $swatchContainer.data('position');
			
			// Desktop color swatches with gallery feature ONLY: use scroll-based position
			if (window.matchMedia && window.matchMedia('(min-width: 769px)').matches && 
			    swatch_wrap_position === 0 && 
			    yswSO.settings.enable_swatch_gallery) {
				if (yswSO.settings.color_popup_scroll_top !== null) {
					$swatchContainer.find('.swatch-preview-window')
						.css('top', yswSO.settings.color_popup_scroll_top + 'px');
				}
				return;
			}

			// All other swatches (including color swatches without gallery): use dynamic positioning relative to hovered item
			var swatch_ul_pos = $swatchContainer.find('ul.swatches').offset().top;
			var swatch_li_pos = current_swatch.offset().top;
			var this_li_height = current_swatch.height();
			var pos_difference = swatch_li_pos - swatch_ul_pos;
			var preview_div_height = current_swatch.closest('.ysw-swatch-options').find('.swatch-preview-window').height();

			//var viewport_height = $(window).height();
			//var distance_from_li_to_bottom = viewport_height - swatch_li_pos;

			var top_position = Math.round(pos_difference - ((preview_div_height - this_li_height) / 2));

			current_swatch.closest('.ysw-swatch-options').find('.swatch-preview-window').css('top', top_position + 'px');

		},
	update_preview_swatch_info: function(current_swatch) {

			// change preview info
	        var swatch_position = current_swatch.data('position');
	        var swatch_wrap_position = current_swatch.closest('.ysw-swatch-options').data('position');

	        eval('var this_swatch = yswSO.settings.swatch_data_' + swatch_wrap_position + '[' + swatch_position + ']');

	        var $previewWindow = $('.ysw-swatch-options[data-position="' + swatch_wrap_position + '"] .swatch-preview-window');

	        var swapImg = function($container, url, alt) {
	        	if (!$container || $container.length === 0) return;
	        	$container.show();

	        	var $existing = $container.find('img');
	        	var $newImg = $('<img/>', { src: url, alt: alt, css: { display: 'none' } });

	        	var reveal = function() {
	        		$newImg.fadeIn(140);
	        	};

	        	if ($existing.length > 0) {
	        		$existing.stop(true, true).fadeOut(80, function() {
	        			$container.empty().append($newImg);
	        			if ($newImg[0].complete) {
	        				reveal();
	        			} else {
	        				$newImg.on('load', reveal);
	        			}
	        		});
	        	} else {
	        		$container.empty().append($newImg);
	        		if ($newImg[0].complete) {
	        			reveal();
	        		} else {
	        			$newImg.on('load', reveal);
	        		}
	        	}
	        };

	        // name (at top)
	        $previewWindow.find('.swatch-name').text(this_swatch.name);

	        // swatch image
	        swapImg($previewWindow.find('.swatch-img'), this_swatch.image_url, this_swatch.name);

	        // Swatch Gallery Feature - Add product preview image (only for color swatches, position 0)
	        if (swatch_wrap_position == 0 && yswSO.settings.enable_swatch_gallery && yswSO.settings.swatch_images) {
	        	var colorImages = yswSO.settings.swatch_images[this_swatch.name];
	        	if (colorImages && colorImages.length > 0) {
	        		var productPreviewUrl = colorImages[0];
	        		if ($previewWindow.find('.swatch-product-preview').length === 0) {
	        			$previewWindow.find('.swatch-img').after('<div class="swatch-product-preview"></div>');
	        		}
	        		swapImg($previewWindow.find('.swatch-product-preview'), productPreviewUrl, this_swatch.name);
	        	} else {
	        		$previewWindow.find('.swatch-product-preview').hide();
	        	}
	        }

	        // price
	        if(this_swatch.price_upcharge > 0) {
	        	if($previewWindow.find('.swatch-upcharge').length > 0) {
	        		$previewWindow.find('.swatch-upcharge').html('Add $' + this_swatch.price_upcharge);
	        	} else {
	        		$previewWindow.append('<div class="swatch-upcharge"> Add $' + this_swatch.price_upcharge + '</div>');
	        	}
		} else {
			$previewWindow.find('.swatch-upcharge').remove();
		}

	},
		is_touch_device: function() {
			return 'ontouchstart' in window || navigator.maxTouchPoints;
		},
		custom_events: function() {

			// Fancybox
			$(".ysw-swatch-options .request-free-swatch-link a.desktop-swatch-link").fancybox({
			  afterShow: function( instance, slide ) {
			    // Image
			    $('.fancybox-container .fancybox-toolbar').appendTo('.fancybox-container .fancybox-image-wrap')
			  }
			});

			if(yswSO.is_touch_device() && window.matchMedia('(pointer:fine)').matches === false) {

				$(document).on('click','.ysw-swatch-options .request-free-swatch-link a.mobile-swatch-link', function() {
					$.fancybox.open({
						src  : yswSO.settings.free_swatch_img_mobile,
						type : 'image'
					});
				})

				// no hover
				// use click

				$(document).click(function() {
				    $('.ysw-swatch-options.ysw-swatch-left').removeClass('show-preview-window');
				});

				$(document).on('click','.ysw-swatch-options ul.swatches li:not(".view-more"):not(".free-swatch-button")', function(e) {

					e.stopPropagation();

					$(this).closest('.ysw-swatch-options').find('ul.swatches li:not(".view-more"):not(".free-swatch-button")').removeClass('selected');
					$(this).addClass('selected');
					var position = Number($(this).data('position'));

					var swatch_position = $(this).closest('.ysw-swatch-options').data('position');
					eval('var this_dropdown = yswSO.settings.swatch_dropdown_' + swatch_position);
					eval('this_swatch_data = yswSO.settings.swatch_data_' + swatch_position);

					this_dropdown.val(this_swatch_data[position].option_val).trigger('change');
                  	this_dropdown[0].dispatchEvent(new Event('change'));
                  	
                  	// Swatch Gallery Feature - Update product images for color swatches (position 0)
                  	console.log('yswSO DEBUG: Swatch clicked, position:', swatch_position, 'enable_swatch_gallery:', yswSO.settings.enable_swatch_gallery);
                  	if (swatch_position == 0 && yswSO.settings.enable_swatch_gallery) {
                  		var colorName = this_swatch_data[position].name;
                  		console.log('yswSO DEBUG: Calling updateProductImages with colorName:', colorName);
                  		yswSO.updateProductImages(colorName);
                  	} else {
                  		console.log('yswSO DEBUG: Skipping updateProductImages - swatch_position:', swatch_position, 'enable_swatch_gallery:', yswSO.settings.enable_swatch_gallery);
                  	}

					yswSO.update_preview_swatch_info($(this));

					// Hide other preview panes
					$('.ysw-swatch-options').removeClass('show-preview-window');
					// show preview pane for this option
				    $(this).closest('.ysw-swatch-options').addClass('show-preview-window');

				    // scroll to swatch preview only in mobile
				    // under 768 pixels
				    // check for mobile menu button to cheeck if truly in mobile
				    if($('.menu_icons button').is(':visible')) {

				    	// remove ysw-swatch-left class if present
				    	// important if user changes device orientation without refreshing page
				    	$('.ysw-swatch-options.show-preview-window').removeClass('ysw-swatch-left');

				    	// remove top inline css
				    	$('.ysw-swatch-options .swatch-preview-window').removeAttr('style');

				    	$.fancybox.open({
							src  : '.ysw-swatch-options.show-preview-window .swatch-preview-window',
							type : 'inline',
							opts : {
								smallBtn: false,
								afterShow: function( instance, slide ) {
								    $('.fancybox-container .fancybox-toolbar').appendTo('.fancybox-container .swatch-preview-window')
								}
							}
						});

					/*    if($('.nav-bar.sticky:visible').length > 0) {
					    	var sticky_header_height = $('.nav-bar.sticky:visible').height();
					    } else if($('header.sticky nav:visible').length > 0) {
					    	var sticky_header_height = $('header.sticky nav:visible').height();
					    } else {
					    	var sticky_header_height = 0;
					    }

					    // if top sitewide banner is showing
					    // add to offset
					    if($('.sumome-smartbar-popup').length > 0) {
					    	sticky_header_height = sticky_header_height + $('.sumome-smartbar-popup').height();
					    }

					    //console.log(sticky_header_height);

					    // scroll to preview
					    $('html, body').stop().animate({
							scrollTop: $(this).closest('.ysw-swatch-options').find('.swatch-preview-window').offset().top - sticky_header_height
						}, 400, function() {

							if(sticky_header_height == 0) {

							if($('.nav-bar.sticky:visible').length > 0) {
							    	sticky_header_height = $('.nav-bar.sticky:visible').height();
							    } else if($('header.sticky nav:visible').length > 0) {
							    	sticky_header_height = $('header.sticky nav:visible').height();
							    } else {
							    	sticky_header_height = 0;
							    }

							    // if top sitewide banner is showing
							    // add to offset
							    if($('.sumome-smartbar-popup').length > 0) {
							    	sticky_header_height = sticky_header_height + $('.sumome-smartbar-popup').height();
							    }

							    if(sticky_header_height > 0) {
								    // scroll again in case sticky header is now present
								    $('html, body').stop().animate({
										scrollTop: $(this).closest('.ysw-swatch-options').find('swatch-preview-window').offset().top - sticky_header_height
									}, 400);
								}

							}

						}); */

					} else {

						yswSO.set_preview_swatch_position($(this));

				    	$(this).closest('.ysw-swatch-options.show-preview-window').addClass('ysw-swatch-left');

					}


				})


			} else {

				// Update color popup position on scroll (only for swatch gallery products)
				var scrollTimeout;
				$(window).on('scroll', function() {
					clearTimeout(scrollTimeout);
					scrollTimeout = setTimeout(function() {
						// Only update if swatch gallery is enabled
						if (yswSO.settings.enable_swatch_gallery) {
							yswSO.update_color_popup_position();
							// If color popup is visible, apply the new position immediately
							if ($('.ysw-swatch-options[data-position="0"].show-preview-window').length > 0) {
								if (yswSO.settings.color_popup_scroll_top !== null) {
									$('.ysw-swatch-options[data-position="0"] .swatch-preview-window')
										.css('top', yswSO.settings.color_popup_scroll_top + 'px');
								}
							}
						}
					}, 50);
				});

				$(document).on({
				    mouseenter: function () {
				        //stuff to do on mouse enter
				        //console.log('hover on');

				        yswSO.update_preview_swatch_info($(this));

						// Calculate position based on scroll ONLY for color swatches with gallery feature enabled
						var swatch_wrap_position = $(this).closest('.ysw-swatch-options').data('position');
						if (swatch_wrap_position === 0 && yswSO.settings.enable_swatch_gallery) {
							yswSO.update_color_popup_position();
						}
						yswSO.set_preview_swatch_position($(this));

				        // show preview pane
				        $(this).closest('.ysw-swatch-options').addClass('show-preview-window');

				    },
				    mouseleave: function () {
				        //stuff to do on mouse leave
				        //console.log('hover off');

				        // hide preview pane
				        $(this).closest('.ysw-swatch-options').removeClass('show-preview-window');

				        // remove position
				        $(this).closest('.ysw-swatch-options').find('.swatch-preview-window').removeAttr('style');

				    }
				}, '.ysw-swatch-options ul.swatches li:not(".view-more"):not(".free-swatch-button")'); //pass the element as an argument to .on

				$(document).on('click','.ysw-swatch-options ul.swatches li:not(".view-more"):not(".free-swatch-button")', function() {
					$(this).closest('.ysw-swatch-options').find('ul.swatches li:not(".view-more"):not(".free-swatch-button")').removeClass('selected');
					$(this).addClass('selected');
					var position = Number($(this).data('position'));

					var swatch_position = $(this).closest('.ysw-swatch-options').data('position');
					eval('var this_dropdown = yswSO.settings.swatch_dropdown_' + swatch_position);
					eval('this_swatch_data = yswSO.settings.swatch_data_' + swatch_position);

					this_dropdown.val(this_swatch_data[position].option_val).trigger('change');
                  	this_dropdown[0].dispatchEvent(new Event('change'));
                  	
                  	// Swatch Gallery Feature - Update product images for color swatches (position 0)
                  	console.log('yswSO DEBUG (desktop): Swatch clicked, position:', swatch_position, 'enable_swatch_gallery:', yswSO.settings.enable_swatch_gallery);
                  	if (swatch_position == 0 && yswSO.settings.enable_swatch_gallery) {
                  		var colorName = this_swatch_data[position].name;
                  		console.log('yswSO DEBUG (desktop): Calling updateProductImages with colorName:', colorName);
                  		yswSO.updateProductImages(colorName);
                  	}
                })

			}

			$(document).on('click','.ysw-swatch-options ul.swatches li.view-more', function() {
				$(this).closest('.ysw-swatch-options').toggleClass('view-all-swatches');
			})


      /* Code commented as the Request FREE Swatches button has a specific link into it and this was an important theme funcionality
      $(document).on('click','.ysw-swatch-options ul.swatches li.free-swatch-button', function() {
				if($(".ysw-swatch-options .request-free-swatch-link a.desktop-swatch-link").is(':visible')) {
					$(".ysw-swatch-options .request-free-swatch-link a.desktop-swatch-link").trigger('click');
				} else {

					$('.ysw-swatch-options .request-free-swatch-link a.mobile-swatch-link').trigger('click');

				}
      }); */

			$(document).on('change', '.bold_option_element select', function() {

				// if ysw_so_position is defined
				// then it's a color swatch related dropdown

				if($(this).data('ysw_so_position') || $(this).data('ysw_so_position') == 0) {

					var select_val = $(this).val();

					var position = $(this).data('ysw_so_position');

					eval('var swatch_data_arr = yswSO.settings.swatch_data_' + position);

					swatch_data_arr.forEach(function(swatch,index) {

						if(swatch.option_val == select_val) {
							var selected_swatch_li = $('.ysw-swatch-options[data-position="' + position + '"] ul.swatches li[data-position="' + index + '"]');
							$('.ysw-swatch-options[data-position="' + position + '"] ul.swatches li:not(".view-more"):not(".free-swatch-button")').removeClass('selected');
							selected_swatch_li.addClass('selected');
						}

					})

				}

			})

		},
		build_html: function() {

			var swatch_type_class = '';

			if(yswSO.settings.swatch_type == 'leather-swatch-main' || yswSO.settings.swatch_type == 'leather-swatch') {

				swatch_type_class = 'leather';

			} else if(yswSO.settings.swatch_type == 'fabric-swatch-main') {

				swatch_type_class = 'fabric-main';

			}else if(yswSO.settings.swatch_type == 'fabric-swatch') {

				swatch_type_class = 'fabric';

			}else if(yswSO.settings.swatch_type == 'kfi-fabric-swatch') {

				swatch_type_class = 'fabric';

			}

			var html = '<div class="ysw-swatch-options-wrapper ' + swatch_type_class + '">';

			// CF 2026-10: these globals are only declared on some product pages; read them safely so the loop can't throw
			var freeSwatchFormUrl = (typeof window.cfFreeSwatchFormUrl === 'string') ? window.cfFreeSwatchFormUrl : (yswSO.settings.free_swatch_form_url || '');
			var enableFreeSwatchesLink = (typeof window.cfEnableFreeSwatchesLink === 'boolean') ? window.cfEnableFreeSwatchesLink : true;

			// Loop through each option
			yswSO.settings.option_names.forEach(function(loop_option, i) {
				eval('var this_swatch_data = yswSO.settings.swatch_data_' + i);

				html += '<div class="ysw-swatch-options" data-position="' + i + '"><div class="swatch-preview-window"><div class="swatch-img"></div><div class="swatch-name"></div></div>';

              // show free swatches on first option
				if(i == 0) {
					html += '<div class="request-free-swatch-link"><a class="desktop-swatch-link" href="' + yswSO.settings.free_swatch_img_desktop + '&utm_source=' + yswSO.settings.swatch_type + '"> </a><a class="mobile-swatch-link"> </a></div>';
				}

				var adjusted_option_name = yswSO.settings.option_names[i].replace('Finish','Finishes').replace('Color','Colors').replace('Type','Types');

				if(freeSwatchFormUrl && i == 0) {
					html += '<div class="swatch-heading swatch-heading--flex">';
					} else {
					html += '<div class="swatch-heading">';
				}

				
				// Append heading suffix only to first option (color swatch) since that's what updates the product image
				var headingSuffix = (i == 0 && yswSO.settings.enable_swatch_gallery && yswSO.settings.heading_suffix) ? ' ' + yswSO.settings.heading_suffix : '';
                html += this_swatch_data.length + ' ' + adjusted_option_name + ':' + headingSuffix;

				if(freeSwatchFormUrl && i == 0 && enableFreeSwatchesLink){
				  html += `<a class="btn" target="_blank"  href="${freeSwatchFormUrl}">Request FREE Swatches</a>`;
				}

				html += '</div><ul class="swatches">';

				this_swatch_data.forEach(function(swatch,index) {
					html += '<li data-position="' + index + '"><img src="' + swatch.image_url + '" alt="' + swatch.name + '"></li>';

				})

				// show view more if length is greater than 15 (needs to match css nth-child hide)
				if(this_swatch_data.length > 15) {
					html += '<li class="view-more"><div class="view-more-inner"><span></span></div></li>';
					if(freeSwatchFormUrl && i == 0) {
						html +=  `<li class="free-swatch-button"><div class="free-swatch-inner"><a target="_blank"  href="${freeSwatchFormUrl}">Request FREE Swatches</a></div></li> `;
					} else {
						html += '<li class="free-swatch-button"><div class="free-swatch-inner">Request FREE Swatches</div></li>';
					}
				}

				html += '</ul></div>';

			});

			html += '</div>';

			// $(html).insertBefore('.bold_options');
            $(html).appendTo('#bold_options_swatcher')
		},
		go: function() {

			// clean up img_cdn_url
			yswSO.settings.img_cdn_url = 'https:' + yswSO.settings.free_swatch_img_desktop;
			yswSO.settings.img_cdn_url = yswSO.settings.img_cdn_url.match(/.+?(?=swatch-popup-2019-desktop)/g)[0];

			function check_bold_loaded() {

				if($('.bold_options .bold_option_title').length > 0) {

					clearInterval(check_bold_timer);

					// check for options and push into yswSO.settings.option_names
					switch (yswSO.settings.swatch_type) {
						case 'leather-swatch-main':
							yswSO.settings.option_names.push('Leather Color');
							break;
						case 'leather-swatch':
							yswSO.settings.option_names.push('Leather Color');
							break;
						case 'fabric-swatch-main':
							yswSO.settings.option_names.push('Fabric Color');
							break;
						case 'fabric-swatch':
							yswSO.settings.option_names.push('Fabric Color');
                        	break;
						case 'kfi-fabric-swatch':
							yswSO.settings.option_names.push('Fabric Color');
					}
					if($('.bold_options select[name="properties[Seat Type]"]').length > 0) {
						yswSO.settings.option_names.push('Seat Type');
					}
					if($('.bold_options select[name="properties[Leg Finish]"]').length > 0) {
						yswSO.settings.option_names.push('Leg Finish');
					}
					if($('.bold_options select[name="properties[Nail Trim Color]"]').length > 0) {
						yswSO.settings.option_names.push('Nail Trim Color');
					}

					yswSO.settings.option_names.forEach(function(loop_option, i) {

						$('.bold_options .bold_option_title').each(function() {

							var label = $(this).text().trim();

							if(loop_option.toLowerCase() == label.toLowerCase()) {
								//console.log('yswSO label match!')

								var select_dropdown = $(this).closest('label').find('>.bold_option_element select');

								select_dropdown.data('ysw_so_position', i);

								eval('yswSO.settings.swatch_dropdown_' + i + '= select_dropdown');

								eval('yswSO.settings.swatch_data_' + i + ' = []');

								select_dropdown.find('option').each(function(index) {

									// skip first option
									if(index > 0) {

										var option_name = $(this).text().trim();

										var option_val = $(this).val();

	  									var price_change = option_name.match(/\[.+\]/g);

	  									//console.log(option_name);

	  									var price;

	  									if(price_change) {
	  										//console.log(price_change[0]);
	  										price = price_change[0].match(/\d+.\d{2}/g)[0];
	  										//console.log(price);
	  										option_name = option_name.replace(/\[.+\]/g,'').trim();
	  									} else {
	  										price = 0;
	  									}

	  									var image_url = yswSO.settings.img_cdn_url + option_name.replace(/\s/g,'-') + '.jpg?d=june21';

	  									//console.log('trimmed: ' + option_name);

	  									var swatch_data_option = {
	  										name: option_name,
	  										price_upcharge: Number(price),
	  										image_url: image_url,
	  										option_val: option_val
	  									}

	  									eval('yswSO.settings.swatch_data_' + i + '.push(swatch_data_option)');

									}

								})

								return false;

							}

						});

					});

					yswSO.build_html();
					yswSO.custom_events();
					
					// Swatch Gallery Feature - preload images and select default swatch
					console.log('yswSO DEBUG: Checking enable_swatch_gallery:', yswSO.settings.enable_swatch_gallery);
					console.log('yswSO DEBUG: swatch_images:', yswSO.settings.swatch_images);
					if (yswSO.settings.enable_swatch_gallery) {
						// Validate swatch_images data before proceeding
						if (yswSO.validateSwatchImages()) {
							console.log('yswSO DEBUG: Initializing swatch gallery feature');
							// Add class to indicate gallery is enabled
							$('.ysw-swatch-options[data-position="0"]').addClass('ysw-has-gallery');
							yswSO.preloadSwatchImages();
							yswSO.initDefaultZoomImage();
							//yswSO.selectDefaultSwatch();
						} else {
							console.warn('yswSO: swatch_images validation failed, disabling swatch gallery');
							yswSO.settings.enable_swatch_gallery = false;
						}
					} else {
						console.log('yswSO DEBUG: Swatch gallery NOT enabled');
					}

				}

			}

			var check_bold_timer = setInterval(check_bold_loaded, 1000);

		},
		// Swatch Gallery Feature - Validate swatch_images data structure
		validateSwatchImages: function() {
			console.log('yswSO DEBUG [validateSwatchImages]: Starting validation...');
			var swatchImages = yswSO.settings.swatch_images;
			console.log('yswSO DEBUG [validateSwatchImages]: swatch_images =', swatchImages);
			console.log('yswSO DEBUG [validateSwatchImages]: typeof swatch_images =', typeof swatchImages);
			
			// Check if swatch_images exists and is an object
			if (!swatchImages || typeof swatchImages !== 'object') {
				console.warn('yswSO: swatch_images is not a valid object');
				return false;
			}
			
			// Check if it has at least one key
			var keys = Object.keys(swatchImages);
			console.log('yswSO DEBUG [validateSwatchImages]: keys.length =', keys.length);
			if (keys.length === 0) {
				console.warn('yswSO: swatch_images is empty');
				return false;
			}
			
			// Validate at least the first entry has a valid array with URLs
			var firstKey = keys[0];
			var firstValue = swatchImages[firstKey];
			console.log('yswSO DEBUG [validateSwatchImages]: firstKey =', firstKey);
			console.log('yswSO DEBUG [validateSwatchImages]: firstValue =', firstValue);
			console.log('yswSO DEBUG [validateSwatchImages]: Array.isArray(firstValue) =', Array.isArray(firstValue));
			if (!Array.isArray(firstValue) || firstValue.length === 0) {
				console.warn('yswSO: swatch_images first entry is not a valid array:', firstKey);
				return false;
			}
			
			// Check if first URL is a string
			console.log('yswSO DEBUG [validateSwatchImages]: firstValue[0] =', firstValue[0]);
			if (typeof firstValue[0] !== 'string' || firstValue[0].length === 0) {
				console.warn('yswSO: swatch_images first URL is not valid');
				return false;
			}
			
			console.log('yswSO: swatch_images validation passed, found', keys.length, 'colors');
			return true;
		},
		// Swatch Gallery Feature - Preload all swatch images for faster switching
		preloadSwatchImages: function() {
			if (!yswSO.settings.swatch_images) return;
			
			Object.keys(yswSO.settings.swatch_images).forEach(function(colorName) {
				var images = yswSO.settings.swatch_images[colorName];
				if (Array.isArray(images)) {
					images.forEach(function(url) {
						var img = new Image();
						img.src = url;
					});
				}
			});
			console.log('yswSO: Preloaded swatch images');
		},
		// Swatch Gallery Feature - Select the default/first swatch on page load
		selectDefaultSwatch: function() {
			var firstSwatch = $('.ysw-swatch-options[data-position="0"] ul.swatches li:not(".view-more"):not(".free-swatch-button")').first();
			if (firstSwatch.length > 0) {
				firstSwatch.addClass('selected');
				
				// Get the color name from the first swatch
				var position = Number(firstSwatch.data('position'));
				if (typeof yswSO.settings.swatch_data_0 !== 'undefined' && yswSO.settings.swatch_data_0[position]) {
					var defaultColorName = yswSO.settings.swatch_data_0[position].name;
					
					// Set the current color to prevent unnecessary updates
					yswSO.settings.current_swatch_color = defaultColorName;
					
					console.log('yswSO: Default swatch selected:', defaultColorName);
				}
			}
		},
		// Swatch Gallery Feature - Initialize zoom for current default image
		initDefaultZoomImage: function() {
			var $mainImage = $('.product-single__photos .bxslider li:first-child img.magniflier');
			if (!$mainImage.length) return;

			var dataLarge = $mainImage.attr('data-large');
			var src = $mainImage.data('large') || dataLarge || $mainImage.attr('src');
			if (!src) return;

			// Prefer the higher-res data-large for the default image if available
			if (dataLarge && $mainImage.attr('src') !== dataLarge) {
				$mainImage.attr('src', dataLarge);
				src = dataLarge;
			}

			// Ensure magnifier has the large image to use
			$mainImage.attr('data-large', src);
			$mainImage.data('large', src);

			// Preload and cache zoom dimensions
			var img = new Image();
			img.onload = function() {
				$mainImage.data('native_width', img.width);
				$mainImage.data('native_height', img.height);
				// If the magnifier glass exists, sync its background
				$('.glass').css('background-image', 'url(' + src + ')');
			};
			img.src = src;
		},
		updateSwatchImageProperty: function(imageUrl) {
			if (!imageUrl) return;
			var $form = $('form[action^="/cart/add"]');
			if ($form.length === 0) return;
			var $input = $form.find('input[name="properties[_swatch_image]"]');
			if ($input.length === 0) {
				$input = $('<input type="hidden" name="properties[_swatch_image]">');
				$form.append($input);
			}
			$input.val(imageUrl);
		},
		// Swatch Gallery Feature - Update only the first product image when swatch is clicked
		updateProductImages: function(colorName) {
			if (!yswSO.settings.enable_swatch_gallery) return;
			
			// Skip if same color is already selected
			if (yswSO.settings.current_swatch_color === colorName) {
				console.log('yswSO: Same color already selected, skipping update');
				return;
			}
			
			yswSO.settings.current_swatch_color = colorName;
			
			var swatchImages = yswSO.settings.swatch_images;
			if (!swatchImages || !swatchImages[colorName]) {
				console.log('yswSO: No images found for color:', colorName);
				return;
			}
			
			var newImageUrl = swatchImages[colorName][0]; // Get first image only
			if (!newImageUrl) {
				console.log('yswSO: No image URL for color:', colorName);
				return;
			}
			
			yswSO.updateSwatchImageProperty(newImageUrl);
			
console.log('yswSO: Updating first image to:', newImageUrl);
		
		// Update the first/main image only
		var $mainImage = $('.product-single__photos .bxslider li:first-child img.magniflier');
		console.log('yswSO DEBUG: Found main image elements:', $mainImage.length);
		if ($mainImage.length > 0) {
			// Add fade effect
			$mainImage.addClass('ysw-fading');
			
			setTimeout(function() {
				console.log('yswSO DEBUG: Updating main image src to:', newImageUrl);
				$mainImage.attr('src', newImageUrl);
				$mainImage.attr('data-large', newImageUrl);
				$mainImage.data('large', newImageUrl); // Update jQuery data cache for zoom
				
				// Update the fancybox link href
				var $fancyboxLink = $mainImage.closest('a.fancybox');
				if ($fancyboxLink.length > 0) {
					$fancyboxLink.attr('href', newImageUrl);
				}
				
				// Remove fade class after image loads
				$mainImage.on('load', function() {
					$mainImage.removeClass('ysw-fading');
				});
				
				// Fallback: remove fade class after short delay if load event doesn't fire
				setTimeout(function() {
					$mainImage.removeClass('ysw-fading');
				}, 300);
				
				// Preload the large image and update zoom cache to prevent flicker
				var largeImg = new Image();
				largeImg.onload = function() {
					// Update cached dimensions with new image dimensions
					$mainImage.data('native_width', largeImg.width);
					$mainImage.data('native_height', largeImg.height);
					// Update glass background for instant zoom
					$('.glass').css('background-image', 'url(' + newImageUrl + ')');
				};
				largeImg.src = newImageUrl;
				
				console.log('yswSO DEBUG: Image update complete');
			}, 200); // End setTimeout for fade effect
		} else {
			console.log('yswSO DEBUG: Main image element NOT FOUND');
		}
			
			// Update first thumbnail
			var $firstThumb = $('.product-single__thumbnails li:first-child img');
			console.log('yswSO DEBUG: Found thumbnail elements:', $firstThumb.length);
			if ($firstThumb.length > 0) {
				$firstThumb.attr('src', newImageUrl);
			}
		}
	}
})(jQuery)
